import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiMailTemplateHelperService } from './mail-template-helper.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApiMailTemplateService {
  constructor(
    public hpr: ApiMailTemplateHelperService,
    private _api: ApiService,
  ) {}

  get(id: number | string) {
    return this._api.get('mail-template/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('mail-template/list', data);
  }

  create(data: any) {
    return this._api.post('mail-template/create', data);
  }

  update(data: any) {
    return this._api.post('mail-template/update', data);
  }

  duplicate(id: number) {
    return this._api.post('mail-template/duplicate/id/' + id);
  }

  remove(id: number) {
    return this._api.post('mail-template/remove/id/' + id);
  }

  autocompleteSource(data = {}) {
    return (text?: string, id?: number) => {
      return this.list(
        text !== null
          ? { ...data, text }
          : { ids: Array.isArray(id) ? id : [id] },
      ).pipe(
        map((result) =>
          result.data.map((item: any) => {
            return {
              id: item.id,
              label: item.name,
              data: item,
            };
          }),
        ),
      );
    };
  }
}
